import {
  Component,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ElementRef,
  HostListener,
  ViewChild,
  OnInit,
} from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  IFbPaletteItem,
  getFbFieldPaletteItems,
  getFbWidgetPaletteItems,
} from '../../utils/fb-palette-catalog.util';
import { generateNewFieldKeyFromSettingsLabel } from '../../../../core/utils/form-fields-formly-configurations/form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';

@Component({
  selector: 'irembogov-fb-add-field-button',
  templateUrl: './fb-add-field-button.component.html',
  styleUrls: ['./fb-add-field-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FbAddFieldButtonComponent implements OnInit {
  @Output() addField = new EventEmitter<FormlyFieldConfig>();
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  showDropdown = false;
  searchQuery = '';

  fieldTypes: IFbPaletteItem[] = [];

  constructor(private elementRef: ElementRef, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    // Fields + widgets, sourced from V1's static lists (see fb-palette-catalog).
    this.fieldTypes = [
      ...getFbFieldPaletteItems(),
      ...getFbWidgetPaletteItems(),
    ];
  }

  get filteredFieldTypes(): IFbPaletteItem[] {
    if (!this.searchQuery.trim()) return this.fieldTypes;
    const query = this.searchQuery.toLowerCase();
    return this.fieldTypes.filter(
      ft =>
        ft.displayName.toLowerCase().includes(query) ||
        ft.type.toLowerCase().includes(query)
    );
  }

  toggleDropdown(): void {
    this.showDropdown = !this.showDropdown;
    this.searchQuery = '';
    if (this.showDropdown) {
      setTimeout(() => this.searchInput?.nativeElement?.focus(), 0);
    }
    this.cdr.markForCheck();
  }

  selectFieldType(fieldType: IFbPaletteItem): void {
    // Clone the V1 template and give it a unique, label-derived key.
    const newField: FormlyFieldConfig = JSON.parse(
      JSON.stringify(fieldType.config)
    );
    generateNewFieldKeyFromSettingsLabel(newField);
    this.addField.emit(newField);
    this.showDropdown = false;
    this.searchQuery = '';
    this.cdr.markForCheck();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.showDropdown = false;
      this.cdr.markForCheck();
    }
  }

  trackByFieldType(index: number, ft: IFbPaletteItem): string {
    return ft.displayName;
  }
}
